import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import View from '../View/View';

import {
  TXTCLI_Chests,
  TXTWCL_You_cannot_view_this_page_due__ELL
} from './ChestInventory.messages.json';
import styles from './ChestInventory.scss';
import ChestAwardMessage from './components/ChestAwardMessage/ChestAwardMessage';
import ChestGrid from './components/ChestGrid/ChestGrid';

export const ChestInventoryBody: React.FC = () => (
  <div className={styles.chestInventory}>
    <ChestAwardMessage />
    <ChestGrid />
  </div>
);

const ChestInventory: React.FC = () => {
  const embedded = useSelector(select.site.isEmbedded);
  const hideChests = useSelector(select.chestInventory.hideChests);

  if (hideChests) {
    return embedded ? (
      <div className={styles.chestInventory}>
        <Translation {...TXTWCL_You_cannot_view_this_page_due__ELL} />
      </div>
    ) : (
      <View title={<Translation {...TXTCLI_Chests} />}>
        <Translation {...TXTWCL_You_cannot_view_this_page_due__ELL} />
      </View>
    );
  }

  return embedded ? (
    <ChestInventoryBody />
  ) : (
    <View title={<Translation {...TXTCLI_Chests} />}>
      <ChestInventoryBody />
    </View>
  );
};

export default ChestInventory;
